import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选专题片单，帮你发现更多值得追的好剧
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-[140px] aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex flex-col justify-center flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-7 h-7 rounded-md bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-xs text-primary-600`}></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}